module.exports = __webpack_public_path__ + "static/media/icon_member_info.4300a6dc.png";